'use client';

import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Autoplay, Keyboard, Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ImageClient } from '@/components/core';
import { MultiassetStoryblok } from '@/types/storyblok/storyblok-types';

import 'swiper/css';

import styles from './ImagesSlider.module.scss';

type ImagesSliderProps = {
    images: MultiassetStoryblok;
    className?: string;
    autoplay?: boolean;
};

export const ImagesSlider: React.FC<ImagesSliderProps> = ({ images, className, autoplay }) => {
    const [swiper, setSwiper] = useState(null);
    const pagination = {
        clickable: true,
        renderBullet(index, classNameBullet) {
            return `<span class="${classNameBullet}"></span>`;
        },
    };

    const stopAutoplay = () => {
        if (swiper) {
            swiper.autoplay.stop();
        }
    };

    const startAutoplay = () => {
        if (swiper) {
            swiper.autoplay.start();
        }
    };

    useEffect(() => {
        if (swiper && autoplay) {
            swiper.autoplay.start();
        }
    }, [swiper, autoplay]);

    return (
        <div
            onMouseEnter={stopAutoplay}
            onMouseLeave={startAutoplay}
            className={clsx(styles.root, className)}
        >
            <Swiper
                modules={[Keyboard, Mousewheel, Pagination, Autoplay]}
                pagination={pagination}
                spaceBetween={16}
                slidesPerView="auto"
                keyboard
                allowTouchMove
                onSwiper={setSwiper}
            >
                {images?.map(data => (
                    <SwiperSlide
                        className={styles.slide}
                        key={data?.id}
                    >
                        <ImageClient
                            key={data.id}
                            className={styles.image}
                            width={584}
                            height={584}
                            src={data.filename}
                            alt={data.alt}
                            focalPoints={data.focus}
                            jsonData={{
                                images: [
                                    {
                                        contentUrl: data.filename,
                                        copyrightNotice: data.copyright,
                                    },
                                ],
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};
